// Filters store module
export default {
  namespaced: true,
  
  state: () => ({
    portal: []
  }),
  
  mutations: {
    setPortal(state, portal) {
      state.portal = portal;
    },
    clearPortal(state) {
      state.portal = [];
    }
  },
  
  actions: {
    setPortal({ commit }, portal) {
      commit('setPortal', portal);
    },
    clearPortal({ commit }) {
      commit('clearPortal');
    }
  },
  
  getters: {
    portal: state => state.portal
  }
};
